import { ReactQueryDevtools as BaseReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';
import { useKey } from 'react-use';

export function ReactQueryDevtools() {
  const [enableDevTools, setEnableDevTools] = useState(false);

  useKey(
    (e) => {
      const target = e.target as HTMLElement | null;
      if (target?.tagName !== 'BODY') return false;

      return e.key === 'T' && e.shiftKey && e.ctrlKey;
    },
    () => {
      setEnableDevTools((it) => !it);
    },
  );

  if (!enableDevTools) {
    return null;
  }

  return <BaseReactQueryDevtools initialIsOpen />;
}
